import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { isNumber } from "lodash";
import { getAgeStr } from "../../clinic/utils/commonUtils";

export const generatePrescriptionPDF = async (
  patientDetails,
  medications,
  vitals,
  symptoms,
  investigations,
  doctorData,
  clinicDetails,
  followUpDate
) => {
  console.log(
    "this is the Data we are receiving in the generatePrescriptionPDF function: ",
    patientDetails,
    medications,
    vitals,
    symptoms,
    investigations,
    doctorData,
    clinicDetails,
    followUpDate
  );

  const symptomsString = symptoms
    ? symptoms.map((symptom) => symptom.label).join(" | ")
    : "No symptoms reported";
  const investigationsString = investigations
    ? investigations.map((investigation) => investigation.label).join(" | ")
    : "No Labs Tests Prescribed";

  const filteredVitals = vitals.filter((vital) => vital.value !== "");
  const vitalsString =
    filteredVitals.length > 0
      ? filteredVitals
          .map((vital) => `${vital.label}: ${vital.value} ${vital.unit}`)
          .join(" | ")
      : "No vitals recorded";

  const { name = "", age = "", gender = "", phone = "" } = patientDetails || {};

  const doctorFirstName = doctorData?.first_name || "";
  const doctorLastName = doctorData?.last_name || "";
  const doctorQualification = doctorData?.doctor_qualification || "";
  const doctorSpeciality = doctorData?.doctor_speciality || "";
  const clinicAddress = clinicDetails?.address || "";

  let contentHTML = `
    <div id="pdf-content" style="font-size: 10px; font-family: Arial, sans-serif; width: 210mm; height: 297mm;">
      <div style="padding: 15mm; box-sizing: border-box; height: 100%;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 5mm;">
          <div>
            <h1 style="font-size: 16px; font-weight: bold; margin: 0;">Dr. ${doctorFirstName} ${doctorLastName}</h1>
            <p style="margin: 2mm 0 0 0;">${doctorQualification}</p>
            <p style="margin: 0;">${doctorSpeciality}</p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0;">${clinicAddress}</p>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5mm;">
          <div>
            <p style="margin: 0;"><strong>Patient:</strong> ${name}, ${gender}, ${getAgeStr(
    age
  )}</p>
            <p style="margin: 0;"><strong>Phone:</strong> ${phone}</p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0;"><strong>Date:</strong> ${moment(
              new Date()
            ).format("DD/MMM/YYYY")}</p>
          </div>
        </div>
        ${
          followUpDate
            ? `
          <div style="text-align: right; margin-bottom: 5mm;">
            <p style="margin: 0;"><strong>Follow-up Date:</strong> ${moment(
              followUpDate
            ).format("DD-MMM-YYYY")}</p>
          </div>
        `
            : ""
        }
        <hr style="border-top: 1px solid #000; margin-bottom: 5mm;">
        <h2 style="font-size: 14px; font-weight: bold; text-decoration: underline; margin-bottom: 3mm;">Consultation Summary</h2>
        <p style="margin-bottom: 5mm;">Chief Complaints: ${symptomsString}</p>`;

  const nonEmptyMedications = medications.filter(
    (med) =>
      med.medicine ||
      med.dosage ||
      med.frequency ||
      med.duration ||
      med.instructions
  );

  if (nonEmptyMedications.length > 0) {
    const medicationRows = nonEmptyMedications
      .map(
        (med) => `
            <tr>
              <td style="border: 1px solid #000; padding: 2mm;">${
                med.medicine
              }</td>
              <td style="border: 1px solid #000; padding: 2mm;">${
                med.dosage
              }</td>
              <td style="border: 1px solid #000; padding: 2mm;">${
                med.frequency
              }</td>
              <td style="border: 1px solid #000; padding: 2mm;">${
                med.duration
              }</td>
              <td style="border: 1px solid #000; padding: 2mm;">${
                med.instructions || "N/A"
              }</td>
            </tr>
          `
      )
      .join("");

    contentHTML += `
      <h2 style="font-size: 14px; font-weight: bold; text-decoration: underline; margin-bottom: 3mm;">Prescription</h2>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 5mm;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Medicine</th>
            <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Dose</th>
            <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Frequency</th>
            <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Duration</th>
            <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Remarks</th>
          </tr>
        </thead>
        <tbody>
          ${medicationRows}
        </tbody>
      </table>`;
  }

  if (investigations && investigations.length > 0) {
    contentHTML += `
      <h2 style="font-size: 14px; font-weight: bold; text-decoration: underline; margin-bottom: 3mm;">Investigations</h2>
      <p style="margin-bottom: 5mm;">${investigationsString}</p>`;
  }

  if (filteredVitals.length > 0) {
    contentHTML += `
      <h2 style="font-size: 14px; font-weight: bold; text-decoration: underline; margin-bottom: 3mm;">Vitals:</h2>
      <p>${vitalsString}</p>`;
  }

  contentHTML += `
      </div>
    </div>`;

  // Create a hidden div element and append the HTML content
  const pdfContainer = document.createElement("div");
  pdfContainer.style.position = "absolute";
  pdfContainer.style.left = "-9999px";
  pdfContainer.style.top = "0px";
  pdfContainer.innerHTML = contentHTML;
  document.body.appendChild(pdfContainer);

  // Use html2canvas to take a snapshot of the div and turn it into a canvas
  const canvas = await html2canvas(pdfContainer, {
    scale: 2.5, // Increase the scale for better resolution
    useCORS: true, // Use CORS to handle external image security
  });

  // Calculate the dimensions of the PDF
  const pdfWidth = 210;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  // Initialize jsPDF
  const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);

  // Add the canvas as an image to the PDF
  const imgData = canvas.toDataURL("image/jpeg", 1.0);
  pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

  // Clean up: Remove the hidden div
  document.body.removeChild(pdfContainer);

  // Output the PDF as a blob
  const pdfBlob = pdf.output("blob");

  // Return the URL for the generated PDF
  return pdfBlob;
};
